<div class="modal fade common-modal" id="success-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" #viewModalDialog	 (keyup.enter)="onEnter()" (keyup.escape)="dialogService.hideDialog(viewModalDialog)" style="z-index: 9999 !important;">
	<div class="modal-dialog modal-sm modal-dialog-centered" style="max-width: 415px;">
	   <div class="modal-content">
		   <div class="modal-body text-center">
			   <a class="icon-modal-close" data-dismiss="modal">
				   <img src="assets/images/icon/icon-modal-close.svg" alt="icon-modal-close"
						class="icon-modal-close-img" />
			   </a>
			   <div class="common-modal-inner" style="margin-top: 30px; margin-bottom: 30px;">
				   <img data-dismiss="modal" src="assets/images/icon/icon-success.svg" alt="icon-success" class="icon-verify-account">
				   <h3 class="mt20 font-weight-500 h22 mt20 text-dark-blue">Success!</h3>
				   <p class="p-16 mt10">{{message}}</p>
				   <div class="posi-rel mt20">
					   <button type="button" class="btn common-btn btn-block" data-dismiss="modal">
						   OK
					   </button>
				   </div>
			   </div>
		   </div>
	   </div>
   </div>
</div>
